InputView = require "views/input"
{ dpi }   = require("lib/device")

class MultipleChoiceSurveyView extends InputView
  template: require("./template")

  events:
    "iostap .selectable": "selectAnswer"
    "iostap .btn-done":   "nextSlide"
    "iostap .multi-content-wrapper-image": "showZoom"

  serialize: ->
    data = super

    data.title = data.question.content
    data.titleType = data.question.contentType
    data.hasPrompt = true
    answers = _.filter(data.answers, "content")
    longest = _.max(answers, (answer) -> answer.content?.length or 0)
    isLong  = longest.content?.length > Math.min(data.width / 16, 30)

    answers =
      for answer in answers
        _.extend {}, answer,
          isLong: isLong
          bottom: /the above/i.test(answer.content)

    answers       = _.shuffle(answers) if data.randomize
    bottomAnswers = _.where(answers, bottom: true)
    otherAnswers  = _.without(answers, bottomAnswers...)
    data.answers  = otherAnswers.concat(bottomAnswers)

    data

  render: ->
    super

    @setEl @findAll(".selectable"), "answers"
    @setEl [], "selected"

  refresh: ->
    super

    @showFocusImage()

  show: ->
    for el in @getEl("answers") or []
      el.classList.remove("active")
    
    @showFocusImage()

  showFocusImage: ->
    canFocusImage = false

    window.setTimeout =>
      for img in @findAll(".multi-content-image")
        imgRect = img.getBoundingClientRect()
        canFocusImage = canFocusImage or imgRect.height < (img.naturalHeight or img.height) or imgRect.width < (img.naturalWidth or img.width)

      @setState canFocusImage, "image-focus"
    , 100

  showZoom: (e) ->
    img  = e.currentTarget.querySelector(".multi-content-image")
    rect = img.getBoundingClientRect()

    if rect.height < (img.naturalHeight or img.height) or
       rect.width  < (img.naturalWidth or img.width)
      @photoswipe = new PhotoSwipe(
        document.querySelector("#photoswipe")
        PhotoSwipeUI_Default
        [
          msrc: img.src
          src:  img.src
          title: written.wrapInTag(@options.data.subtitle or "", "h2")
          w: (img.naturalWidth  or img.width)  / Math.min(dpi, 1.66)
          h: (img.naturalHeight or img.height) / Math.min(dpi, 1.66)
        ]
        {
          focus: false
          history: false
          barsSize: {top: 0, bottom: 0 }
          getThumbBoundsFn: -> { x: rect.left, y: rect.top, w: rect.width }
        }
      )

      @photoswipe.listen("close", => @setState(false, "focus"))
      @photoswipe.init()

  userInput: (e) ->
    selected = $(@getEl("selected"))
    question =
      id: @options.data.question.id
      text: @options.data.question.content
    answer =
      text: _.map(selected, (el) -> $(el).text()).join('|')
    if @options.data.selectable is 1
      answer.id = selected.data('answer-id')
    return { question, answer }

  selectAnswer: (e) ->
    return if @currentState.state is "complete"

    selected = @getEl("selected")
    el       = e.currentTarget

    if @options.data.selectable is 1 and
       el.classList.contains("active")
      return

    el.classList.toggle("active")

    if el.classList.contains("active")
      if selected.length >= @options.data.selectable
        selected.shift()?.classList.remove("active")

      selected.push(el)
    else
      selected = _.without(selected, el)

    @setEl(selected, "selected")

    if selected.length is 0
      @setState("prompt")
    else
      @setState("touched")

module.exports = MultipleChoiceSurveyView
